import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faBalanceScale, faCircleExclamation, faGear } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/corporate.jpg';

function CorporateGovernanceScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Corporate Governance & Compliance'>
          <Breadcrumb parent="Services" screen='Corporate Governance & Compliance'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Corporate Governance & Compliance"
          description="Navigate complex regulatory landscapes confidently with PocketLPO’s Corporate Governance & Compliance services. We provide tailored solutions to help your business meet its governance and compliance needs effectively."
          services={[
            "Governance audits and compliance checks.",
            "Corporate structuring.",
            "Assistance with GDPR, HIPAA, and CCPA compliance frameworks."
          ]}
          benefits={[
            { title: "Proactive Compliance", description: "Stay ahead of regulatory changes.", icon: faBalanceScale },
            { title: "Custom Solutions", description: "Tailored services for your industry and location.", icon: faGear },
            { title: "Risk Reduction", description: "Minimize exposure to legal and financial penalties.", icon: faCircleExclamation }
          ]}
          image={image}
        />
    </>
  );
}

export default CorporateGovernanceScreen;
